import React, {useState} from 'react'
import './ModalWide.css'

const ModalDeleteProtocol = ({closeModal, onSubmit, protocolEdit, sessionCount = 0}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState('');

    const protocolInfo = protocolEdit;

    const isActiveProtocol = !!protocolInfo?.is_active;
    const hasSessions = Number(sessionCount) > 0;
    const canPermanentlyDelete = !isActiveProtocol && !hasSessions;
    const showBlockedDeleteMessage = !isActiveProtocol && hasSessions;

    const apiDeactivateProtocol = async (protocol_id) => {
        const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/protocols/protocol/' + protocol_id,
            {
                method: 'PATCH',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ is_active: false }),
            });

        if (!response.ok) {
            throw new Error(`Failed to deactivate protocol ${protocol_id}`);
        }

        await response.json();
    }

    const apiDeleteProtocol = async (protocol_id) => {
        const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/protocols/protocol/' + protocol_id,
            {
                method: 'DELETE',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    'content-type': 'application/json'
                },
            });

        if (!response.ok) {
            throw new Error(`Failed to delete protocol ${protocol_id}`);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) {
            return;
        }

        setSubmitError('');
        setIsSubmitting(true);
        try {
            if (canPermanentlyDelete) {
                await apiDeleteProtocol(protocolInfo.id);
                onSubmit('delete');
            }
            else {
                await apiDeactivateProtocol(protocolInfo.id);
                onSubmit('deactivate');
            }
            closeModal();
        } catch (error) {
            console.error(error);
            setSubmitError(canPermanentlyDelete ? 'Unable to delete protocol. Please try again.' : 'Unable to deactivate protocol. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleClose = (e) => {
        e.preventDefault();
        closeModal();
    }

    return (
    <div className='modal-container' onClick={(e) => {
        if (e.target.className === "modal-container")
        closeModal()
    }}>
      <div className='modal-edit'>
        <form>
        <div className='row'>
            <div className='column-half'>
                <div className='form-group'>
                    <label htmlFor='protocol_id'>
                        {canPermanentlyDelete ? 'Delete' : 'Deactivate'} {protocolInfo.name ?? protocolInfo.protocol_name}: Protocol ID: {protocolInfo.id}
                    </label>
                </div>
            </div>
        </div>
        <div className='row'>
            {isActiveProtocol && <p>Are you sure you want to Deactivate this protocol?</p>}
            {canPermanentlyDelete && <p>This protocol is already inactive. This will permanently delete the protocol.</p>}
            {showBlockedDeleteMessage && <p>This protocol cannot be deleted because it has {sessionCount} attached session{Number(sessionCount) === 1 ? '' : 's'}.</p>}
        </div>

        {submitError && <div className='error'>{submitError}</div>}
        <div className='row'>
            <div className='column-third'>
                <div className='form-group'>
                    {!showBlockedDeleteMessage && (
                        <button type='submit' className='btn' onClick={handleSubmit} disabled={isSubmitting}>
                            {isSubmitting ? (canPermanentlyDelete ? 'Deleting...' : 'Deactivating...') : (canPermanentlyDelete ? 'Delete' : 'Deactivate')}
                        </button>
                    )}
                </div>
            </div>
            <div className='column-third'>
                <div className='form-group'>
                <button type='submit' className='btn' onClick={handleClose} disabled={isSubmitting}>{showBlockedDeleteMessage ? 'OK' : 'Cancel'}</button>
                </div>
            </div>
        </div>
        </form>
      </div>
    </div>
  )
}

export default ModalDeleteProtocol
